import http from "./httpService";
import { uploadApi } from "./config.json";

export async function uploadPOFile(fd) {
  const { data } = await http.post(uploadApi + "uploadPO.php", fd);
  return data;
}
export async function uploadSCApprovalFile(fd) {
  const { data } = await http.post(uploadApi + "uploadSCApproval.php", fd);
  return data;
}

export async function uploadSupplierConfirmationFile(fd) {
  const { data } = await http.post(
    uploadApi + "uploadSupplierConfirmation.php",
    fd
  );
  return data;
}

export async function uploadFormClaim(document) {
  const { data } = await http.post(uploadApi + "uploadFormClaim.php", document);
  return data;
}
export async function uploadConfirmationDocument(fd) {
  const { data } = await http.post(
    uploadApi + "uploadConfirmationDocument.php",
    fd
  );
  return data;
}
export async function uploadExcelItem(fd) {
  const { data } = await http.post(uploadApi + "uploadExcelItem.php", fd);
  return data;
}

export async function uploadItem(fd) {
  const { data } = await http.post(uploadApi + "uploadItem.php", fd);
  return data;
}

export async function uploadItemSupporting(fd) {
  const { data } = await http.post(uploadApi + "uploadItemSupporting.php", fd);
  return data;
}

export async function uploadSignDocument(fd) {
  const { data } = await http.post(uploadApi + "uploadSignDocument.php", fd);
  return data;
}

export async function uploadSignMarketing(fd) {
  const { data } = await http.post(uploadApi + "uploadSignMarketing.php", fd);
  return data;
}

export async function uploadPOConfirmationFile(document, id_purchase_order) {
  const { data } = await http.post(
    uploadApi + "uploadPOConfirmationFile.php?q=" + id_purchase_order,
    document
  );
  return data;
}

export async function uploadPOConfirmationDocument(
  document,
  id_purchase_order
) {
  const { data } = await http.post(
    uploadApi + "uploadPOConfirmationDocument.php?q=" + id_purchase_order,
    document
  );
  return data;
}

export async function uploadQCMobil(fd) {
  const { data } = await http.post(uploadApi + "uploadQCMobil.php", fd);
  return data;
}


// WEBPACK FOOTER //
// ./src/services/uploadServices.js